<template>
    <nav aria-label="breadcrumb" class="mb-3">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a href="#" @click.prevent="handleLogoClick(groupName)">{{ $trans('web_search.tabbed_search_bar.home') }}</a>
            </li>
            <li class="breadcrumb-item">
                <a href="https://www.deutscheinterim.com/matchmaker" target="_blank">{{ $trans('web_search.tabbed_search_bar.matchmaker') }}</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                {{ currentBreadcrumb }}
            </li>
        </ol>
    </nav>
    <div class="search-bar-container">
        <div class="tabs" v-if="!isMobile">
            </div>

        <div class="search-content">
            <component :is="currentComponent" :main-filters="mainFilters"
                @searchResults="$emit('searchResults', $event)" :group-name="groupName" ref="searcherRef"/>
        </div>
    </div>
</template>

<script>
import Searcher from './Searcher.vue';
import Enterprise from './Enterprise.vue';
import Engage from './Engage.vue';

export default {
    components: {
        Searcher,
        Enterprise,
        Engage,
    },
    props: {
        mainFilters: {
            type: Array,
            required: false,
            default: () => []
        },
        groupName: String,
    },
    data() {
        return {
            activeTab: 'searcher',
            infoVisible: false,
            isMobile: window.innerWidth <= 790,
        };
    },
    computed: {
        tabs() {
            return [
                { label: this.$trans('web_search.tabbed_search_bar.tabs.searcher'), key: "searcher" },
                { label: this.$trans('web_search.tabbed_search_bar.tabs.enterprise'), key: "enterprise" },
                { label: this.$trans('web_search.tabbed_search_bar.tabs.engage'), key: "engage" },
            ];
        },
        infoTitles() {
            return {
                searcher: this.$trans('web_search.tabbed_search_bar.info_titles.searcher'),
                enterprise: this.$trans('web_search.tabbed_search_bar.info_titles.enterprise'),
                engage: this.$trans('web_search.tabbed_search_bar.info_titles.engage')
            };
        },
        infoTexts() {
            return {
                searcher: this.$trans('web_search.tabbed_search_bar.info_texts.searcher'),
                enterprise: this.$trans('web_search.tabbed_search_bar.info_texts.enterprise'),
                engage: this.$trans('web_search.tabbed_search_bar.info_texts.engage')
            };
        },
        currentComponent() {
            switch (this.activeTab) {
                case 'enterprise':
                    return 'Enterprise';
                case 'engage':
                    return 'Engage';
                default:
                    return 'Searcher';
            }
        },
        currentInfoText() {
            return this.infoTexts[this.activeTab] || '';
        },
        currentInfoTitle() {
            return this.infoTitles[this.activeTab] || '';
        },
        currentBreadcrumb() {
            switch (this.activeTab) {
                case 'enterprise':
                    return this.$trans('web_search.tabbed_search_bar.breadcrumb.enterprise');
                case 'engage':
                    return this.$trans('web_search.tabbed_search_bar.breadcrumb.engage');
                default:
                    return this.$trans('web_search.tabbed_search_bar.breadcrumb.searcher');
            }
        },
        currentUrl() {
            return window.location.origin;
        },
    },
    created() {
        this.setActiveTabFromUrl();
        this.$nextTick(this.updateVisibility);
        window.addEventListener('popstate', () => {
            this.setActiveTabFromUrl();
            this.$nextTick(this.updateVisibility);
        });
    },
    mounted() {
        const url = new URL(window.location.href);
        this.debugMode = url.searchParams.has("debug") ? !!url.searchParams.get("debug") : false;
        const returnUrl = url.searchParams.get('returnUrl');

        if (returnUrl) {
            sessionStorage.setItem('external_return_path', decodeURIComponent(returnUrl));
        }
        
        window.addEventListener("resize", this.updateIsMobile);
    },
    beforeUnmount() {
        window.removeEventListener('popstate', this.setActiveTabFromUrl);
        window.removeEventListener("resize", this.updateIsMobile);
    },
    methods: {
        handleLogoClick(groupName) {
            const savedUrl = sessionStorage.getItem('external_return_path');
            const group = groupName.toLowerCase();
        
            if (savedUrl) {
                const urlLower = savedUrl.toLowerCase();

                const isSwiss = group.includes('swiss') && urlLower.includes('swissinterim');
                const isDeutsche = group.includes('deutsche') && urlLower.includes('deutscheinterim');
            
                if (isSwiss || isDeutsche) {
                    window.location.href = savedUrl;
                    return;
                }
            }
        
            window.location.href = this.currentUrl + '/web-search/results/de';
        },
        navigateToTab(tabKey) {
            const url = new URL(window.location);
            url.searchParams.set('tab', tabKey);
            window.history.pushState({}, '', url);
            this.activeTab = tabKey;
            this.$nextTick(this.updateVisibility);
        },
        setActiveTabFromUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            const tabParam = urlParams.get('tab');
            if (tabParam && ['searcher', 'enterprise', 'engage'].includes(tabParam)) {
                this.activeTab = tabParam;
            } else {
                this.activeTab = 'searcher';
            }
        },
        searchResults(payload) {
            this.$emit('searchResults', payload);
        },
        toggleInfo() {
            this.infoVisible = !this.infoVisible;
        },
        updateVisibility() {
            const shouldHide = this.activeTab === 'enterprise' || this.activeTab === 'engage';
            const profileListWrapper = document.querySelector('.profile-list-wrapper');
            const profilePlaceholderWrapper = document.querySelector('.profile-placeholder-wrapper');

            if (profileListWrapper) profileListWrapper.style.display = shouldHide ? 'none' : '';
            if (profilePlaceholderWrapper) profilePlaceholderWrapper.style.display = shouldHide ? 'none' : '';
        },
        updateIsMobile() {
            this.isMobile = window.innerWidth <= 790;
        },
    },
    created() {
        this.setActiveTabFromUrl();
        this.$nextTick(this.updateVisibility);
        window.addEventListener('popstate', () => {
            this.setActiveTabFromUrl();
            this.$nextTick(this.updateVisibility);
        });
    },
    beforeUnmount() {
        window.removeEventListener('popstate', this.setActiveTabFromUrl);
        window.removeEventListener("resize", this.updateIsMobile);
    },
    mounted() {
        window.addEventListener("resize", this.updateIsMobile);
    },
};
</script>

<style scoped>
.search-bar-container {
    width: 100%;
    position: relative;
    border-radius: 12px;
    border-top-left-radius: 0;
}

.tabs {
    position: absolute;
    top: -36px;
    display: flex;
    gap: 10px;
}

.tab {
    background: #ffffff;
    padding: 8px 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    cursor: pointer;
    color: #1C1C1C;
    border: 1px solid #ddd;
    border-bottom: none;
    transition: all 0.3s ease;
}

.tab.active {
    background: #CDDEE2 0% 0% no-repeat padding-box;
}

.info-icon {
    width: 22px;
    height: 22px;
    background-color: #B1B1B1;
    border: none;
    border-radius: 50%;
    font-size: 19px;
    font-weight: bold;
    cursor: pointer;
    text-align: center;
    line-height: 22px;
    margin-left: 16px;
    padding: unset;
    font-family: "KaTeX Math", serif;
    color: #fff;
}

.info-icon:hover {
    background-color: #bbb;
}

:deep(.info-popover) {
    height: 300px !important;
}

.el-popover :deep(.el-popper__arrow) {
    display: none !important;
}

:deep(.el-popover__title) {
    text-align: center;
}

.info-content {
    position: relative;
}

.info-content p {
    letter-spacing: -0.36px;
    color: #3C3C3C;
    font: normal normal normal 18px/32px Inter;
    margin-top: -17px;
}

.info-icon:hover {
    background-color: #bbb;
}

.popover-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
}

.info-icon-large {
    width: 35px;
    height: 35px;
    background-color: #41ABC4;
    color: white;
    border-radius: 50%;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    line-height: 35px;
    font-family: "KaTeX Math", serif;
}

.popover-title {
    text-align: center;
    font: italic normal 500 32px/50px Cormorant Garamond;
    letter-spacing: -0.96px;
    color: #4D5255;
    opacity: 1;
}

.info-content {
    font-size: 14px;
    color: #333;
    text-align: center;
}

.close-btn {
    position: absolute;
    top: 6px;
    right: 14px;
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;
    color: #707070;
}

.search-bar-container .tabs {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
}

.search-bar-container .info-icon {
    margin-left: auto;
}

.mobile-tabs {
    margin-bottom: 10px;
}

.mobile-tabs select {
    width: 100%;
    padding: 8px 12px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
}

.breadcrumb {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0 0 23px 6px;
    background-color: transparent;
    font-size: 14px;
    margin-bottom: -12px;
  }
  
  .breadcrumb .breadcrumb-item {
    text-align: left;
    font: normal normal normal 18px/28px Barlow;
    letter-spacing: -0.32px;
    color: #3c3c3c;
    position: relative;
    display: flex;
    align-items: center;
  }
  
  .breadcrumb-item a {
    text-decoration: none;
    transition: color 0.2s ease;
    color: #3c3c3c;
  }
  
  .breadcrumb-item a:hover {
    text-decoration: underline;
    color: #41ABC4;
  }
  
  .breadcrumb-item + .breadcrumb-item::before {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 8px solid #41ABC4;
    margin: 0 12px;
    margin-bottom: -4px;
  }
  
</style>
